/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'

export type DescriptionProps = {
  description: string
}

export const Description = ({ description }: DescriptionProps) => {
  return (
    <div css={descriptionStyle}>
      <p>{description}</p>
    </div>
  )
}

const descriptionStyle = css`
  padding: 0px 20px;

  & p {
    margin-top: 30px;
  }
`
